import SecuritySalt from "../utils/consts/SecuritySalt";

export const sha256 = async (text = ""): Promise<string> => {
	if (text) {
		const msgBuffer = new TextEncoder().encode(text + SecuritySalt);

		const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

		const hashArray = Array.from(new Uint8Array(hashBuffer));

		const hashHex = hashArray.map((b) => ("00" + b.toString(16)).slice(-2)).join("");
		return hashHex;
	} else {
		return "";
	}
};
